import PaymentInstrumentDataAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/vault/_vaultedPaymentMethod/paymentInstrumentData.mdx";
import VaultedPaymentMethodIdAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/vault/_vaultedPaymentMethod/vaultedPaymentMethodId.mdx";
import VaultedPaymentMethodAnalyticsIdAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/vault/_vaultedPaymentMethod/vaultedPaymentMethodAnalyticsId.mdx";
import VaultedPaymentMethodPaymentInstrumentTypeAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/vault/_vaultedPaymentMethod/vaultedPaymentMethodPaymentInstrumentType.mdx";
import * as React from 'react';
export default {
  PaymentInstrumentDataAndroid,
  VaultedPaymentMethodIdAndroid,
  VaultedPaymentMethodAnalyticsIdAndroid,
  VaultedPaymentMethodPaymentInstrumentTypeAndroid,
  React
};